export const REQUEST_SUBJECT = `Получить расчет (блок фильтров)`;
